'use client';

import { ActionButtons } from '@/components/molecules';
import { ModalWrapper } from '@/components/organisms';

interface ConfirmWithdrawMatchModalProps {
	setShowModal: (showModal: boolean) => void;
	gameNumber: number;
	teamName: string;
	onConfirm: () => void;
}

export const ConfirmWithdrawMatchModal = ({ setShowModal, gameNumber, teamName, onConfirm }: ConfirmWithdrawMatchModalProps) => {
	const withdrawMessage = `Please confirm the withdrawal from Game ${gameNumber}. This game will be recorded as 0-0, and the opposing team will be marked as the winner. Withdrawn games do not count toward ratings or any stats other than a game win.`;

	return (
		<ModalWrapper
			overlayClassName="z-10"
			className="max-w-[500px]"
			title="Confirm withdraw"
			onClose={() => setShowModal(false)}
			closeOnOutsideClick
		>
			<div className="flex flex-col gap-4 py-5">
				<p className="text-lg font-medium text-orange-500">{teamName}</p>
				<p className="text-sm font-medium text-gray-700">{withdrawMessage}</p>
			</div>

			<ActionButtons
				className="flex justify-end gap-3"
				closeButtonClassName="w-32"
				submitButtonClassName="w-32"
				onClose={() => setShowModal(false)}
				onSubmit={onConfirm}
				submitButtonText="Confirm"
				closeButtonText="Cancel"
				submitButtonDisabled={false}
			/>
		</ModalWrapper>
	);
};
